/* global swal, _, angular*/
import './style.less';

export default function($log, $q, $stateParams) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.keyLength = item => Object.keys(item).length;

  function activate() {
    $log.debug('Course Info Component Activated');
    $log.debug('Course Info Component Data', vm.ngModel);

    if (!vm.ngModel) $log.error(`No Course Information ${$stateParams.eventid}`);

    vm.loaded = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/courseSummary/controller.js